module.exports = __webpack_public_path__ + "static/media/Lisa Rhodes Headshot.fb47c5bc.png";